// Mirror of EuropassPdfHobbiesSection.jsx: bullet title + comma-separated hobbies.

import { bulletSectionTitle, run } from "../../shared/wordHelpers";
import { FONT_VERDANA } from "../../shared/wordTheme";
import { EU_INDENT, euPara } from "../euLayout";

export function buildEuropassHobbies( { data, translations } ) {
    const { hobbies } = data;

    const text = hobbies
        .filter( hobby => hobby.text && hobby.text !== "" )
        .sort( ( a, b ) => a.order - b.order )
        .map( hobby => hobby.text )
        .join( ", " );

    return [
        ...bulletSectionTitle( translations?.pdf?.hobbiesTitle, { font: FONT_VERDANA, indent: EU_INDENT } ),
        euPara( run( text, { pt: 8, font: FONT_VERDANA } ) ),
    ];
}
